import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-generic-accordion-attachment',
  templateUrl: './generic-accordion-attachment.component.html',
  styleUrls: ['./generic-accordion-attachment.component.scss']
})
export class GenericAccordionAttachmentComponent implements OnInit {

  @Input() attachment: any;
  @Output()
  sendAction = new EventEmitter()  
  constructor() {
  }
  ngOnInit() {
    
  }
  getFile(url)
  {
    if(url!=''&&url!=null&&url!=undefined)
    {
      window.open(url,'_blank');
    }
  }
}


// WEBPACK FOOTER //
// /codebuild/output/src77755007/src/src/app/generic-ui-components/generic-accordion-attachment/generic-accordion-attachment.component.ts